const articlCategory = {
  root: "category",
  root_plural: "categories",
};
export default articlCategory;
